import Vue from 'vue';
import injector from 'vue-inject';
import moment from 'moment';

require('../../start');

Vue.use(injector);

let api         = injector.get('api'),
    datetime    = injector.get('datetime'),
    status      = injector.get('status');

const state = {
    boughtPackets: [],

    boughtPacketsSettings: {
        currentPage: 1,
        numberOfPages: 1,
        maxPerPage: 25,
        fromDate: false,
        toDate: false,
        sort: []
    }
};

const getters = {
    boughtPackets: state => {
        return state.boughtPackets
    },

    boughtPacketsSettings: state => {
        return state.boughtPacketsSettings
    }
};

const mutations = {
    /**
     * Set bought packets in store
     * @param state
     * @param data
     */
    setBoughtPackets (state, data) {
        if (data.results.length > 0) {
            Vue.set(state, 'boughtPackets', data.results)
        } else {
            Vue.set(state, 'boughtPackets', [])
        }
        Vue.set(state.boughtPacketsSettings, 'currentPage', data.current_page);
        Vue.set(state.boughtPacketsSettings, 'maxPerPage', data.max_per_page);
        Vue.set(state.boughtPacketsSettings, 'numberOfPages', data.number_of_pages);
    }
};

const actions = {

    /**
     * Get bought packets data from api
     * @param commit
     * @param data
     * @returns {Promise<any>}
     */
    async loadBoughtPackets ({ commit }, data) {

        if(!data) {
            return;
        }

        return new Promise((resolve, reject) => {
            let settings = Object.create(data);
            if (settings.params.sort) {
                let sort = [];
                for (let field in data.params.sort) {
                    sort.push(data.params.sort[field]);
                }
                settings.params.sort = sort;
            }
            Vue.http.get(api.package.boughtList(settings.params)).then(response => {
                commit('setBoughtPackets', response.data);
                resolve();
            }, error => {
                status['status' + error.status]();
                reject();
            });
        });
    },

    /**
     * Set sorting in bought packets
     * @param field
     * @returns {Promise}
     */
    async boughtPacketsSetSort ({},  field) {
        return new Promise((resolve) => {
            let sort = state.boughtPacketsSettings.sort,
                isSet = false;

            for (let sortId in sort) {
                if (!isSet && sort[sortId].field === field) {
                    isSet = sortId;
                }
            }

            if (!isSet) {
                sort.push({
                    field: field,
                    order: 'ASC'
                });
            } else {
                sort[isSet].order = sort[isSet].order === 'DESC' ? 'ASC' : 'DESC';
            }

            Vue.set(state.boughtPacketsSettings, 'sort', sort);

            resolve();
        });
    },

    /**
     * Set max number of items in bought packets
     * @param getters
     * @param data
     * @returns {Promise}
     */
    async boughtPacketsSetItems ({}, data) {
        return new Promise((resolve) => {
            Vue.set(state.boughtPacketsSettings, 'maxPerPage', data);

            resolve();
        })
    },

    /**
     * Set page in bought packets
     * @param getters
     * @param data
     * @returns {Promise}
     */
    async boughtPacketsSetPage ({}, data) {
        return new Promise((resolve) => {

            Vue.set(state.boughtPacketsSettings, 'currentPage', data);

            resolve();
        });
    },

    /**
     * Set date in bought packets
     * @param date
     * @returns {Promise}
     */
    async boughtPacketsSetDate ({}, date) {
        return new Promise((resolve) => {

            let dates = date.split(' to ');

            if (dates[1]) {
                Vue.set(state.boughtPacketsSettings, 'fromDate', datetime.localToUtc(dates[0]));
                Vue.set(state.boughtPacketsSettings, 'toDate', datetime.localToUtc(dates[1]));
            } else {
                Vue.set(state.boughtPacketsSettings, 'fromDate', datetime.localToUtc(dates[0]));
                Vue.set(state.boughtPacketsSettings, 'toDate', datetime.localToUtc(moment().format()));
            }

            resolve();
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/boughtPackets.js